:host {
  display: block;
}
.wrapper {
  padding: var(--sl-spacing-large) var(--sl-spacing-medium);
  border: 2px dashed var(--agwa-border-strong);
  border-radius: var(--sl-border-radius-medium);
  background: var(--agwa-surface-raised);
  text-align: center;
  color: var(--agwa-text-muted);
  font-size: var(--sl-font-size-small);
  display: flex;
  flex-direction: column;
  gap: var(--sl-spacing-small);
  align-items: center;
  justify-content: center;
  margin-top: var(--sl-spacing-large);
}
.icon sl-icon {
  font-size: 1.9rem;
  color: var(--agwa-text-muted);
}
.title {
  font-weight: 600;
  color: var(--agwa-text);
  font-size: var(--sl-font-size-medium);
}
::slotted(*) {
  margin: 0;
}
